import React from "react";
import {
  Alert,
  Box,
  Checkbox,
  Divider,
  FormControlLabel,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import {
  formatAmount,
  formatDateTime,
  getLineNumber,
  isRowSelectable,
} from "./paypalUtils";

export default function PayPalImportPreview({
  previewData,
  rows,
  visibleRows,
  hideBankCredits,
  onToggleHideBankCredits,
  selection,
  selectedCount,
  selectableCount,
  allSelected,
  someSelected,
  onToggleAll,
  onToggleRow,
}) {
  return (
    <Box>
      <Divider sx={{ my: 2 }} />
      <Stack direction={{ xs: "column", md: "row" }} spacing={2} alignItems="center">
        <Typography variant="h6">Vorschau</Typography>
        <Typography variant="body2" color="text.secondary">
          {previewData.validRows ?? 0} valide, {previewData.errorRows ?? 0} fehlerhaft,{" "}
          {previewData.totalRows ?? rows.length} gesamt
        </Typography>
        {selection && (
          <Typography variant="body2" color="text.secondary">
            Auswahl: {selectedCount} von {selectableCount}
          </Typography>
        )}
        <FormControlLabel
          control={
            <Checkbox checked={hideBankCredits} onChange={onToggleHideBankCredits} />
          }
          label="Bankgutschriften ausblenden"
        />
      </Stack>
      {visibleRows.length ? (
        <Box sx={{ overflowX: "auto", mt: 2 }}>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell padding="checkbox">
                  <Checkbox
                    checked={Boolean(allSelected)}
                    indeterminate={Boolean(someSelected)}
                    onChange={onToggleAll}
                    inputProps={{ "aria-label": "Alle auswaehlen" }}
                  />
                </TableCell>
                <TableCell>Zeile</TableCell>
                <TableCell>Datum</TableCell>
                <TableCell>Typ</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>Name</TableCell>
                <TableCell align="right">Netto</TableCell>
                <TableCell align="right">Gebuehr</TableCell>
                <TableCell>Waehrung</TableCell>
                <TableCell>Transaktions-ID</TableCell>
                <TableCell>Beschreibung</TableCell>
                <TableCell>Fehler</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {visibleRows.map((row, index) => {
                const hasErrors = Array.isArray(row.errors) && row.errors.length > 0;
                const lineNumber = getLineNumber(row, index);
                const selectable = isRowSelectable(row);
                return (
                  <TableRow
                    key={`${lineNumber}`}
                    sx={hasErrors ? { backgroundColor: "rgba(244,67,54,0.06)" } : undefined}
                  >
                    <TableCell padding="checkbox">
                      <Checkbox
                        checked={Boolean(selection && selection.has(lineNumber))}
                        disabled={!selectable}
                        onChange={() => onToggleRow(row, index)}
                        inputProps={{ "aria-label": `Datensatz ${lineNumber}` }}
                      />
                    </TableCell>
                    <TableCell>{lineNumber}</TableCell>
                    <TableCell>{formatDateTime(row.dateTime)}</TableCell>
                    <TableCell>{row.type || "-"}</TableCell>
                    <TableCell>{row.status || "-"}</TableCell>
                    <TableCell>{row.name || "-"}</TableCell>
                    <TableCell align="right">
                      {formatAmount(row.netAmount, row.currency)}
                    </TableCell>
                    <TableCell align="right">
                      {formatAmount(row.feeAmount, row.currency) || "-"}
                    </TableCell>
                    <TableCell>{row.currency || "-"}</TableCell>
                    <TableCell>{row.providerTransactionId || "-"}</TableCell>
                    <TableCell>{row.description || "-"}</TableCell>
                    <TableCell>{hasErrors ? row.errors.join("; ") : "-"}</TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </Box>
      ) : (
        <Alert severity="info" sx={{ mt: 2 }}>
          Keine Transaktionen erkannt.
        </Alert>
      )}
    </Box>
  );
}
